/* eslint-disable no-underscore-dangle */
import React from 'react';
import moment from 'moment';
import PropTypes, { any } from 'prop-types';

import DatePicker from '../../../../components/Form/Datepicker';

import styles from '../../search.scss';

const MIN_PREVIOUS_DATE = moment().subtract(6, 'months');
export const IN_PROGRESS_EVENTS_DATE = moment().subtract(1, 'months');
const dt = moment();
export const currentGMTTime = dt.subtract(dt.parseZone().utcOffset(), 'minutes');
export const tomorrowDateGmt = moment();
export const yesterdayGMTTime = moment().subtract(1, 'days');

const DateFilter = props => {
    const { startDate, endDate, fromDateChange, toDateChange, handleFilterUpdate, minDate, maxDate, onlyCustom, 'data-testid': dataTestId } = props;

    const earliestPossibleDate = minDate || moment().subtract(5, 'years');
    const momentStartDate = moment(startDate || earliestPossibleDate);
    const momentEndDate = moment(endDate || moment());
    const dateSelectOptions = [

        { value: 'allFuture', label: 'Upcoming Events' },
        { value: 'allInProgress', label: 'In Progress Events' },
        { value: 'allPast', label: 'Past Events' },
        { value: 'custom', label: 'Custom Date Range' },
    ];
    const customDateSelectOptions = props.customDateSelectOptions ? props.customDateSelectOptions : dateSelectOptions;

    let dateSelectValue = 'custom';

    if (!onlyCustom) {
        if (startDate && startDate._isAMomentObject) {
            if (momentStartDate.isSame(IN_PROGRESS_EVENTS_DATE, 'day')) {
                dateSelectValue = 'allInProgress';
            }
            if (momentStartDate.isSame(tomorrowDateGmt, 'day')) {
                if (!(endDate && endDate._isAMomentObject)) {
                    dateSelectValue = 'allFuture';
                }
            }
        }
        if (endDate && endDate._isAMomentObject && momentEndDate.isSame(yesterdayGMTTime, 'day')) {
            dateSelectValue = 'allPast';
        }
    }

    const handleDateSelectChange = e => {
        switch (e.target.value) {
            case 'allPast':
                fromDateChange(MIN_PREVIOUS_DATE);
                toDateChange(yesterdayGMTTime);
                handleFilterUpdate({ startDate: MIN_PREVIOUS_DATE, endDate: yesterdayGMTTime });
                break;
            case 'allInProgress':
                fromDateChange(IN_PROGRESS_EVENTS_DATE);
                toDateChange(moment().add(1, 'months'));
                handleFilterUpdate({ startDate: IN_PROGRESS_EVENTS_DATE, endDate: moment().add(1, 'months') });

                break;

            case 'allFuture':
                fromDateChange(tomorrowDateGmt);
                toDateChange(null);
                handleFilterUpdate({ startDate: tomorrowDateGmt, endDate: null });
                break;

            default:
                fromDateChange(moment());
                toDateChange(moment().add(1, 'days'));
                handleFilterUpdate({ startDate: moment(), endDate: moment().add(1, 'days') });
                break;
        }
    };

    return (
        <>
            {customDateSelectOptions.map(option => {
                return (
                    <div className="row" key={option.value}>
                        <div className="col">
                            <input
                                type="radio"
                                name={`dateSelectOption_${option.value}`}
                                id={`dateSelectOption_${option.value}`}
                                value={option.value}
                                className="standalone-radio"
                                checked={dateSelectValue === option.value}
                                onChange={handleDateSelectChange}
                                data-testid={dataTestId && `${dataTestId}.option-${option.value}.radio`}
                            />
                            <label htmlFor={`dateSelectOption_${option.value}`} data-testid={dataTestId && `${dataTestId}.option-${option.value}.label`}><span />{option.label}</label>
                        </div>
                    </div>
                );
            })}
            {dateSelectValue === 'custom' && (
                <div>
                    <div className={`${styles.searchFilterInputLabel} pt0`} data-testid={dataTestId && `${dataTestId}.from-label`}>From</div>
                    <div className="row">
                        <div className="col">
                            <DatePicker
                                hiddenLabel={true}
                                selected={momentStartDate}
                                placeholder={'From...'}
                                onChange={(momentObj) => { handleFilterUpdate({ startDate: momentObj }); }}
                                minDate={earliestPossibleDate}
                                maxDate={maxDate || null}
                                data-testid={dataTestId && `${dataTestId}.from-date`}
                            />
                        </div>
                    </div>
                    <div className={styles.searchFilterInputLabel} data-testid={dataTestId && `${dataTestId}.to-label`}>To</div>
                    <div className="row">
                        <div className="col">
                            <DatePicker
                                hiddenLabel={true}
                                selected={momentEndDate}
                                placeholder={'To...'}
                                onChange={(momentObj) => { handleFilterUpdate({ endDate: momentObj }); }}
                                minDate={momentStartDate}
                                maxDate={maxDate || null}
                                data-testid={dataTestId && `${dataTestId}.to-date`}
                            />
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

DateFilter.propTypes = {
    maxDate: PropTypes.objectOf(any).isRequired,
    minDate: PropTypes.objectOf(any).isRequired,
    startDate: PropTypes.objectOf(any),
    endDate: PropTypes.objectOf(any),
    fromDateChange: PropTypes.func,
    toDateChange: PropTypes.func,
    handleFilterUpdate: PropTypes.func,
    onlyCustom: PropTypes.bool,
    'data-testid': PropTypes.string,
};
DateFilter.defaultProps = {
    fromDateChange: () => { },
    toDateChange: () => { },
    handleFilterUpdate: () => { },
    startDate: {},
    endDate: {},
    onlyCustom: false,
    'data-testid': undefined,
};

export default DateFilter;
